import React, { Suspense, lazy } from 'react';
import {
  BrowserRouter as Router, Route, Routes,

} from 'react-router-dom';
import './App.css';
import Layout from './component/layout/Layout';
import { SectionsRefProvider } from './context/SectionsRefContext';
import ScrollToTop from './component/ScrollToTop';
import PageLoader from './component/loader/PageLoader';

// Lazy loading des pages
const Home = lazy(() => import('./screen/Home'));
const Experience = lazy(() => import('./screen/Experience'));
const WebSite = lazy(() => import('./screen/WebSite'));

function App() {
  return (
    <Router>
      <ScrollToTop />
      <SectionsRefProvider>

        <Layout>
          <Suspense fallback={<PageLoader />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/mobile-apps" element={<Experience />} />
              <Route path="/web-sites" element={<WebSite />} />
            </Routes>
          </Suspense>
        </Layout>
      </SectionsRefProvider>
    </Router>
  );
}

export default App;
